var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsKeyboardArrowDownRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99987 9.98385C7.91098 9.98385 7.82476 9.96719 7.7412 9.93385C7.65765 9.90052 7.58831 9.85608 7.5332 9.80052L4.46654 6.73385C4.34431 6.61163 4.2832 6.45608 4.2832 6.26719C4.2832 6.0783 4.34431 5.92274 4.46654 5.80052C4.58876 5.6783 4.74431 5.61719 4.9332 5.61719C5.12209 5.61719 5.27765 5.6783 5.39987 5.80052L7.99987 8.40052L10.5999 5.80052C10.7221 5.6783 10.8776 5.61719 11.0665 5.61719C11.2554 5.61719 11.411 5.6783 11.5332 5.80052C11.6554 5.92274 11.7165 6.0783 11.7165 6.26719C11.7165 6.45608 11.6554 6.61163 11.5332 6.73385L8.46654 9.80052C8.39987 9.86719 8.32765 9.91452 8.24987 9.94252C8.17209 9.97052 8.08876 9.9843 7.99987 9.98385Z",
    fill: "#5E5E62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsKeyboardArrowDownRounded);
export default __webpack_public_path__ + "static/media/material-symbols_keyboard-arrow-down-rounded.e930786208425f71c2126a35d5a3f327.svg";
export { ForwardRef as ReactComponent };